import React from 'react'
import styles from './Avatar.module.css'
import vars from '../../vars.css'

const Avatar = props => {
  var avatarStyle = {
    backgroundImage: `url(${props.photo}), linear-gradient(to top, ${
      vars.blue
    }, ${vars.green})`,
  }
  return <div className={styles.avatar} style={avatarStyle} />
}

export default Avatar



// WEBPACK FOOTER //
// ./src/components/Avatar/Avatar.js